import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {WinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/WinPresentationController";
import {ThorParsedGameData} from "../../server/data/ThorParsedGameData";
import {ThorGameConfig} from "../../ThorGameConfig";

/**
 * Created by Jerker Nord on 2019-05-16.
 */

export class ThorNoWinHammerRuneWPController extends WinPresentationController {

    private _cleanUp:boolean;

    constructor(indexes:[number, number]) {
        super(indexes, {name : "ThorNoWinHammerRuneWPController", skippable : false});
    }

    protected parseFeatureGameData(data:ThorParsedGameData):void {
        if(data.runeRazeTriggered == true || data.hammerTimeTriggered == true) {
            this._cleanUp = true;
        } else {
            this._cleanUp = false;
        }
    }

    protected hasWin():boolean {
        return this._cleanUp;
    }

    protected startWinPresentation():void {
        // Go through all symbols. If state is LIT, change to normal
        for(let i:number = 0; i < 5; i++) {
            for(let j:number = 0; j < 3; j++) {
                if(Reels.getSymbol(i, j)!.currentState == ThorGameConfig.instance.SYMBOL_STATES.lit) {
                    Reels.getSymbol(i, j)!.changeState({
                        state : ThorGameConfig.instance.SYMBOL_STATES.normal,
                        fadeInDuration : 0.4
                    });
                }
            }
        }

        this.finish();
    }

    protected stopWinPresentation(isAborted:boolean):void {
        //No abortion needed
    }
}